// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Util from './lib/util';
import myRouter from "./router/routerList";
import axios from 'axios';
import VueRouter from "vue-router"
import VueLazyload from "vue-lazyload"


import $ from "jquery";

import "./scss/quanzi.pc.scss";

Vue.config.productionTip = false;
Vue.config.debug = true;
Vue.prototype.$loading = true;
//Vue.use(VueRouter);
let components = {};
let module = require(`./modules/${window.vueModule}`).default;
//let md = module.default;
components[window.vueModule] = module;

console.log(`Using '${window.vueModule}' to render`);


//PC上不进行APP登录判断等，方便pc调试
Vue.use(VueLazyload , {
    silent : false ,
    //attempt : 1,    //
    adapter : {
        //lazyload 默认情况下回出现重复加载的问题，使用 css类进区分
        loaded (data){
            $(data.el).removeClass('preimg');
        }
    }
});

new Vue({
    el: '#app',
    //router: myRouter,
    components : components,
    template : `
    <div id="appCont">
        <${window.vueModule} />
    </div>
`
});



// WEBPACK FOOTER //
// ./src/main.js